module.exports = __webpack_public_path__ + "static/media/brecka - android.df58a813.png";